<template>
  <div class="detail-wrapper">
    <div class="detail-wrapper-content">
      <div class="title">详细信息</div>
      <div class="img-wrapper">
        <div
          v-for="(item, index) in petInfo.picture"
          :key="index"
          class="img-item"
        >
          <img :src="item" class="slide-image" @click="previewImage(index)" />
        </div>
      </div>
      <div class="pet-detail-wrapper">
        <div class="pet-title">
          <div class="text">宠物信息</div>
          <div v-if="petInfo.status === '待领养'" class="status">
            {{ petInfo.status }}
          </div>
          <div v-else class="status send">{{ petInfo.status }}</div>
        </div>
        <div class="info-wrapper">
          <div v-if="!petInfo.title">
            <div class="row">
              <div class="item">昵称：{{ petInfo.name }}</div>
              <div class="item">年龄: {{ petInfo.age }}</div>
            </div>
            <div class="row">
              <div class="item">收养类型：{{ petInfo.type }}</div>
              <div class="item">绝育：{{ petInfo.is_sterilized }}</div>
              <div class="item">驱虫：{{ petInfo.is_deinsect }}</div>
            </div>
            <div class="row">
              <div class="item">免疫：{{ petInfo.is_immune }}</div>
              <div class="item">城市：{{ petInfo.city }}</div>
              <div class="item">是否免费: {{ petInfo.price_status }}</div>
            </div>
            <div v-if="petInfo.price_status == '有偿'" class="row">
              <div class="item">有偿金额：{{ petInfo.price }}</div>
            </div>
            <div v-if="petInfo.price_status == '收押金'" class="row">
              <div class="item">押金金额：{{ petInfo.deposit_price }}</div>
              <div class="item">押金期限：{{ petInfo.deposit_period }}</div>
            </div>
          </div>
        </div>
        <div class="desc-content">
          <div class="desc-title">宠物描述:</div>
          <div class="desc-item">
            <div v-if="petInfo.title">{{ petInfo.title }}</div>
            <div>{{ petInfo.desc }}</div>
          </div>
        </div>
        <div v-if="!petInfo.title" class="require-content">
          <div class="require-title">领养要求:</div>
          <div class="require-item">{{ petInfo.require }}</div>
          <div class="tips">
            温馨提示：没有面对面见到宠物之前，索要定金、押金、空运费多数都是骗子，切勿打款，请务必联系管理员dechonglingyang核实！
          </div>
        </div>
      </div>
      <div class="publisher-wrapper">
        <div class="title-wrapper">
          <div class="publish-title">发布人信息</div>
          <!-- <div class="report-btn" @click="report">举报</div> -->
        </div>
        <div class="qrcode-wrapper">
          <p>关注公众号查看发布人信息</p>
          <img
            class="qrcode"
            src="https://dechong.oss-cn-qingdao.aliyuncs.com/system/publish_qrcode.jpg"
            alt=""
          />
        </div>
        <!-- <div class="user-info-content">
          <div class="avatar-wrapper">
            <img class="avatar" :src="petInfo.avatar" />
          </div>
          <div class="user-desc">
            <div class="user-desc-item">
              昵称：{{ petInfo.nickname || "暂无" }}
            </div>
            <div class="user-desc-item">
              发布人身份：{{ petInfo.owner_type || "暂无" }}
            </div>
            <div class="user-desc-item">
              <span class="item"
                >手机号：{{
                  petInfo.status === "待领养"
                    ? petInfo.phone || "暂无"
                    : "***********"
                }}</span
              >
            </div>
            <div class="user-desc-item">
              <span class="item"
                >微信号：{{
                  petInfo.status === "待领养"
                    ? petInfo.wechat || "暂无"
                    : "******"
                }}</span
              >
            </div>
          </div>
        </div>-->
      </div>
      <!-- <div class="btn-wrapper"></div> -->
      <div
        v-if="poserShow"
        data-wrapper="poster"
        class="poster-wrapper"
        @click="hidePoster"
      >
        <img class="poster" :src="posterUrl" />
        <div class="btn-save">保存图片</div>
      </div>
    </div>
    <a class="bottom" href="http://www.beian.miit.gov.cn/">
      <div class="c-name">北京得宠科技</div>
      <div class="icp">京ICP备18031539号</div>
    </a>
  </div>
</template>

<script>
// @ is an alias to /src
import { getPublishDetail, addReadCount } from "@/util/api";
import Pub from "@/util/publish";

export default {
  name: "Detail",
  components: {},
  data() {
    return {
      item_id: "",
      posterUrl: "",
      poserShow: false,
      petInfo: {}
    };
  },
  computed: {
    now() {
      return +new Date();
    }
  },
  created() {
    this.item_id = this.$route.params.item_id;
    this._getDetail();
  },
  methods: {
    async _getDetail() {
      this.$Toast.loading({
        mask: true,
        duration: 0,
        message: "加载中..."
      });
      let _petInfo = await getPublishDetail(this.item_id);
      let petInfo = Object.assign({}, _petInfo);
      this.$Toast.clear();

      let imageOption = {
        src: "?x-oss-process=image/resize,m_fill,h_240,w_240",
        dst: "?x-oss-process=image/resize,l_800"
      };
      petInfo = Pub.changeFormat(petInfo, { img: imageOption });
      petInfo.dstPicture = petInfo.dstPicture.splice(0, 3);
      petInfo.picture = petInfo.picture.splice(0, 3);
      this.petInfo = petInfo;
      addReadCount({ item_id: this.item_id });
      // this.drawCanvas(Object.assign({}, petInfo, {picture: _petInfo.picture}));
    },
    report() {},
    previewImage(index) {
      this.$ImagePreview({
        images: this.petInfo.picture.map(item => {
          return item;
        }),
        startPosition: index
      });
    }
  }
};
</script>

<style scoped lang="less">
@import "../common/less/variable.less";
.detail-wrapper {
  text-align: left;
  padding-bottom: 40 / 2px;
  .detail-wrapper-content {
    position: relative;
    z-index: 100;
    background-color: #fff;
  }
  .title {
    padding: 13 / 2px 0 22 / 2px;
    font-size: 30 / 2px;
    line-height: 42 / 2px;
    text-align: center;
    color: @color-text-orange;
  }
  .img-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 30 / 2px;
    width: 100%;
    .img-item {
      margin: 20 / 2px;
      display: inline-block;
      width: 200 / 2px;
      height: 200 / 2px;
      overflow: hidden;
      image {
        width: 200 / 2px;
        height: 200 / 2px;
      }
    }
  }
  .swiper-wrapper {
    margin: 0 auto 30 / 2px;
    width: 600 / 2px;
    height: 300 / 2px;
    swiper-item {
      display: flex;
      justify-content: center;
      align-items: center;
      image {
        width: 600 / 2px;
        height: 300 / 2px;
      }
    }
  }
  .pet-detail-wrapper {
    padding-bottom: 20 / 2px;
    border-bottom: #c7c7c7 solid 4 / 2px;
    .pet-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 55 / 2px 0 20 / 2px;
      margin-bottom: 15 / 2px;
      .text {
        padding-left: 8 / 2px;
        font-size: 30 / 2px;
        line-height: 42 / 2px;
        color: @color-text-orange;
        width: 360 / 2px;
        border-bottom: #c7c7c7 solid 2 / 2px;
        padding-bottom: 10 / 2px;
      }
      .status {
        font-size: 30 / 2px;
        line-height: 42 / 2px;
        color: @color-text-orange;
        &.send {
          color: @color-text-gray;
        }
      }
    }
    .info-wrapper {
      padding: 0 55 / 2px;
      .row {
        display: flex;
        align-self: center;

        .item {
          width: 30%;
          flex: 1 1 auto;
          color: #000;
          font-size: 26 / 2px;
          line-height: 42 / 2px;
        }
      }
    }
    .desc-content,
    .require-content {
      padding: 0 55 / 2px;
      margin-top: 30 / 2px;
      color: #000;
      font-size: 26 / 2px;
      line-height: 42 / 2px;
    }
    .tips {
      margin-top: 10 / 2px;
      font-size: 24 / 2px;
      line-height: 1.4;
      color: rgba(0, 0, 0, 0.6);
    }
  }
  .publisher-wrapper {
    margin-top: 22 / 2px;
    border-bottom: #c7c7c7 solid 4 / 2px;
    .title-wrapper {
      width: 100%;
      box-sizing: border-box;
      padding-right: 40 / 2px;
      display: flex;
      justify-content: space-between;
      .publish-title {
        padding-left: 8 / 2px;
        font-size: 30 / 2px;
        line-height: 42 / 2px;
        color: @color-text-orange;
        width: 360 / 2px;
        border-bottom: #c7c7c7 solid 2 / 2px;
        padding-bottom: 10 / 2px;
        margin-bottom: 15 / 2px;
        margin-left: 20 / 2px;
      }
      .report-btn {
        font-size: 26 / 2px;
        color: #616161;
      }
    }
    .qrcode-wrapper {
      padding-left: 22px;
      .img {
        width: 80px;
        height: 80px;
      }
    }
    .user-info-content {
      padding-left: 55 / 2px;
      display: flex;
      align-items: center;
      .avatar-wrapper {
        flex: none;
        display: flex;
        align-items: center;
        width: 120 / 2px;
        height: 120 / 2px;
        margin-right: 40 / 2px;
        img {
          width: 100%;
          height: auto;
        }
      }
      .user-desc {
        flex: auto;
        font-size: 26 / 2px;
        padding-right: 40 / 2px;
        width: 50%;
        .user-desc-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 5 / 2px 0;
          .copy,
          .call {
            font-size: 26 / 2px;
            color: @color-text-orange;
            position: relative;
            &::before {
              content: "";
              position: absolute;
              top: -10 / 2px;
              right: -30 / 2px;
              bottom: -10 / 2px;
              left: -30 / 2px;
            }
          }
        }
      }
    }
  }
  .btn-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20 / 2px 30 / 2px;
    .component-form {
      flex: 1 1 auto;
      width: 80 / 2px;
      margin: 12px 20 / 2px;
      .focus,
      .share {
        display: inline-block;
        width: 190 / 2px;
        height: 60 / 2px;
        background: url("@{img-baseurl}btn.png") 0 0 no-repeat;
        background-size: 100% 100%;
        text-align: center;
        border-radius: 6 / 2px;
        color: #000;
        line-height: 60 / 2px;
        font-size: 20 / 2px;
      }
    }
  }
  .canvas-wrapper {
    position: absolute;
    top: -9999px;
    left: -9999px;
    z-index: 0;
  }
  .poster-wrapper {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
    box-sizing: border-box;
    padding-top: 40 / 2px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .poster {
      margin: 0 auto 30 / 2px;
      width: 500 / 2px;
      height: 890 / 2px;
    }
    .btn-save {
      margin: 0 auto;
      width: 525 / 2px;
      height: 70 / 2px;
      text-align: center;
      line-height: 70 / 2px;
      border-radius: 6 / 2px;
      font-size: 20 / 2px;
      color: #000;
      background: url("@{img-baseurl}btn.png") 0 0 no-repeat;
      background-size: 100% 100%;
    }
  }
  .bottom {
    font-size: 12px;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #999;
    .c-name {
      margin-right: 10px;
    }
  }
}
</style>
